<template>
  <div id="codificator-builder-new-or-edit" class="wrapper-content w-100">
    <LmComponentLoading v-if="isLoading" fixed />
    <h1>{{ $t('document_types_generator') }}</h1>
    <LmForm ref="lmFormRef" id="documentTypes-header">
      <!-- <portal-target name="destination-after-title" slim/> -->
      <LmTextInput
        :disabled="formData.publish"
        class="col-12 px-0"
        :v="$v.formData.typeName"
        v-model="formData.typeName"
        :label="$t('document_type_name')"
        :placeholder="$t('document_type_name_placeholder')"
      />
      <LmTextInput
        :disabled="formData.publish"
        class="col-12 px-0"
        :v="$v.formData.typeAlias"
        v-model="formData.typeAlias"
        :label="$t('document_type_alias')"
        :placeholder="$t('document_type_alias_placeholder')"
      />
      <LmTextArea
        :disabled="formData.publish"
        class="col-12 px-0"
        v-model="formData.typeDescription"
        :v="$v.formData.typeDescription"
        :label="$t('document_type_description')"
        :placeholder="$t('document_type_description_placeholder')"
      />
      <b-row class="mt-4">
        <LmRadio
          :disabled="!formData.isEditable"
          v-model="formData.typeNumerator"
          name="numerator"
          :label="$t('numerator_type')"
          class="col-12 col-md-3"
          isVertical
          :help="$t('numerator_type_help')"
          :options="[
            {text: $t('generic'), value: 'generic'},
            {text: $t('specific'), value: 'specific'}
          ]"
        />
        <LmRadio
          :disabled="!formData.isEditable"
          v-model="formData.typeComunicable"
          name="comunicable"
          :label="$t('comunicable_type')"
          class="col-12 col-md-3"
          isVertical
          :help="$t('comunicable_type_help')"
          :options="[
            {text: $t('comunicable'), value: 'comunicable'},
            {text: $t('incomunicable'), value: 'incomunicable'}
          ]"
        />
        <LmRadio
          :disabled="!formData.isEditable"
          v-model="formData.typeVisibility"
          name="visibility"
          :label="$t('visibility_type')"
          class="col-12 col-md-3"
          isVertical
          :help="$t('visibility_type_help')"
          :options="[
            {text: $t('public'), value: 'public'},
            {text: $t('private'), value: 'private'}
          ]"
        />
        <LmRadio
          :disabled="!formData.isEditable"
          v-model="formData.typeSignature"
          name="signature"
          :label="$t('signature_type')"
          class="col-12 col-md-3"
          isVertical
          :help="$t('signature_type_help')"
          :options="[
            {text: $t('electronic'), value: 'electronic'},
            {text: $t('digital'), value: 'digital'}
          ]"
        />
      </b-row>
      <b-row>
        <LmTextInput
          :disabled="!formData.isEditable"
          class="col-12 col-md-3"
          v-model="formData.typePrefix"
          :v="$v.formData.typePrefix"
          :label="$t('prefix')"
          :placeholder="$t('numerator_prefix')"
          :help="$t('numerator_prefix_help')"
        />
      </b-row>
    </LmForm>
    <b-row>
      <h3 class="col-12">Permisos para las instancias</h3>
      <LmTreeSelect
        class="col-6"
        multiple
        pathToGetOptions="/codificatorbuilder/codificators/60ef327157c5ac23d879c0fb"
        label="Área"
        v-model="formData.instancePrivileges.area"
      />
      <LmTreeSelect
        class="col-6"
        multiple
        pathToGetOptions="/codificatorbuilder/codificators/60ef334457c5ac23d879c100"
        label="Subárea"
        v-model="formData.instancePrivileges.subarea"
      />
      <LmTreeSelect
        class="col-12"
        multiple
        pathToGetOptions="/codificatorbuilder/codificators/60ef336657c5ac23d879c105"
        label="Rol"
        v-model="formData.instancePrivileges.role"
      />
    </b-row>
    <hr class="w-100">
    <!-- FormBuilderUi -->
    <div id="lm-form-builder-ui" class="wrapper-content w-100 px-0 mt-3">
      <div class="row position-relative">
        <div class="col-12 mt-3">
          <b-form-group :label="$t('view_modes')">
            <b-form-radio-group buttons button-variant="primary" v-model="modes.selected">
              <b-form-radio
                :disabled="!formData.isEditable"
                name="viewMode"
                value="edit"
                @change="modes.editView = $event === 'edit'"
              >
                <font-awesome-icon class="mr-1" icon="wrench" />
                {{ $t('edit_mode') }}
              </b-form-radio>
              <b-form-radio
                name="viewMode"
                value="preview"
                @change="modes.editView = $event === 'edit'"
              >
                <font-awesome-icon class="mr-1" icon="eye" />
                {{ $t('preview_mode') }}
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>
        <div class="col-12">
          <h3>{{ !formData.isEditable ? 'Previsualización del formulario' : 'Formulario de ingreso de datos' }}</h3>
          <b-row>
            <LmSuperPowerSelectV2
              v-if="formData.isEditable"
              class="col-12 col-md-6"
              :options="documentTypesOptionsForDuplicate"
              @input="loadFormElements"
              :label="$t('import_form_components_from_another_document_type')"
            />
          </b-row>
          <div class="row" v-if="componentsOptions.content.length">
            <div class="col-12 col-md-6 px-0" v-show="modes.editView">
              <LmForm ref="lmFormBuilderRef" id="documentFormElements">
                <draggable
                  class="col-12"
                  v-model="form.formElements"
                  @start="drag=true"
                  @end="drag=false"
                  animation="150"
                  handle=".handle"
                  >
                  <div v-for="(formElement, index) in form.formElements" :key="formElement.id" class="mt-4">
                    <header
                      class="d-flex justify-content-between align-items-center bg-primary text-white px-3 handle shadow rounded-lg"
                      :class="{'bg-info': !shouldCreatePortal(form.formElements[index].componentName)}">
                      <font-awesome-icon class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
                      <h4 v-b-toggle="`collapse-${index}`" class="flex-grow-1 text-center my-0 py-3 handle">{{title(form.formElements[index])}}</h4>
                      <div v-if="shouldCreatePortal(form.formElements[index].componentName)" class="circle d-flex justify-content-center align-items-center">{{index}}</div>
                      <div class="d-flex align-items-center">
                        <font-awesome-icon v-b-toggle="`collapse-${index}`" class="ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                        <font-awesome-icon class="ml-4 clickable" icon="trash" @click="removeFormElement(index)" style="width:16px; height:16px;" />
                      </div>
                    </header>
                    <b-collapse
                      accordion="my-accordion"
                      :id="`collapse-${index}`"
                      visible
                      class="p-4 border border-top-0 rounded-lg"
                      >
                      <LmSelect
                        :id="'select-elements-' + index"
                        v-model="form.formElements[index].componentName"
                        :options="componentsOptions"
                        :label="$t('select_elemet_type')"
                        @input="selectorElementForm($event, index)"
                      />
                      <component
                        :index="index"
                        :is="whatComponentBuilderUse(form.formElements[index].componentName)"
                        :id="form.formElements[index].formObjectToSendToServerProperty || form.formElements[index].id"
                        :componentData="form.formElements[index]"
                        :optionsChildOf="buildOptionsChildOf(form.formElements[index].formObjectToSendToServerProperty)"
                        :leftValueToCompareOptions="leftValueToCompareOptions(form.formElements[index])"
                        :visibilityDependOnConditions="form.formElements[index].visibilityDependOnConditions"
                        :optionsSameAsValidation="{content: buildSameAsOptions(form.formElements)}"
                        :validationsData="getValidation(form.formElements[index].formObjectToSendToServerProperty)"
                        :options="lmSuperPowerSelectV2BuilderUiOptions"
                        :isOnEditMode="isOnEditMode"
                        @input="inputHandler($event, index)"
                        @validations-changes="validationsChangesHandler"
                      />
                      <hr class="w-100">
                      <section class="row">
                        <h4 class="col-12">Propiedades para el PDF</h4>
                        <LmCheckbox
                          :disabled="formElement.hasLabelOnPdf"
                          class="col-12"
                          labelSingle="Ocultar al generar el PDF"
                          v-model="formElement.isHiddenOnPdf"
                        />
                        <LmCheckbox
                          :disabled="formElement.isHiddenOnPdf"
                          class="col-12"
                          labelSingle="Incluir título del campo en el PDF"
                          v-model="formElement.hasLabelOnPdf"
                        />
                      </section>
                    </b-collapse>
                  </div>
                </draggable>
                <div class="col-12">
                  <LmButton
                    id="add-field-button"
                    class="mt-4"
                    type="button"
                    lmButtonRootWrapperClass="d-inline-block"
                    lmButtonWrapperClass="col"
                    @click.native="addFormElement(form.formElements.length)"
                    :value="$t('add_field')"
                  />
                </div>
              </LmForm>
            </div>
            <!-- Preview del formbuilder que se generará -->
            <div class="col-12 mt-4" :class="{ 'col-md-6': modes.editView }">
              <LmFormBuilder
                class="px-0"
                :getComponents="form"
                :isOnPreviewMode="modes.editView"
                @openEditFormElement="openEditFormElement"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FormBuilderUi -->
    <hr class="w-100">
    <div class="d-flex wrapper-content pl-0">
      <LmButton
        class="col-auto pl-0"
        type="cancel"
        :value="$t('cancel')"
        buttonClass="btn-secondary"
        @click="onCancel()"
      />
      <LmButton
        v-if="!formData.publish && formData.isEditable"
        class="col-auto"
        type="button"
        :value="$t('save')"
        buttonClass="btn-primary"
        @click="onSubmit()"
      />
      <LmButton
        v-if="isOnEditMode && !formData.publish"
        class="col-auto"
        type="button"
        :value="$t('save_and_publish')"
        buttonClass="btn-info"
        :requireConfirmation="true"
        :confirmationTitle="$t('publish_confirmation_title')"
        :confirmationMessage="$t('publish_confirmation_message')"
        @click="onPublish()"
      />
      <LmButton
        v-if="isOnEditMode && formData.publish"
        class="col-auto"
        type="button"
        value="Despublicar"
        buttonClass="btn-warning"
        :requireConfirmation="true"
        :confirmationTitle="$t('defuse_confirmation_title')"
        :confirmationMessage="$t('defuse_confirmation_message')"
        @click="onUnpublish()"
      />
      <LmButton
        v-if="isOnEditMode"
        class="col-auto"
        type="button"
        :value="$t('delete')"
        buttonClass="btn-danger"
        action="delete"
        @click="onDelete()"
      />
    </div>
  </div>
</template>

<script>
import {
  required,
  maxLength
} from 'vuelidate/lib/validators'

import LmForm from '@/components/form/LmForm'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmButton from '@/components/form/elements/LmButton'
import LmRadio from '@/components/form/elements/LmRadio'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import draggable from 'vuedraggable'
import VueScrollTo from 'vue-scrollto'
import LmFormBuilder from '@/components/LmFormBuilder'

import LmTextNumberEditorTextAreaPasswordBuilderUi from '@/components/lmFormBuilderUi/LmTextNumberEditorTextAreaPasswordBuilderUi'
import LmEmailInputBuilderUi from '@/components/lmFormBuilderUi/LmEmailInputBuilderUi'
import LmFormSubtitlesBuilderUi from '@/components/lmFormBuilderUi/LmFormSubtitlesBuilderUi'
import LmFormEmptySpaceBuilderUi from '@/components/lmFormBuilderUi/LmFormEmptySpaceBuilderUi'
import LmFormSeparatorBuilderUi from '@/components/lmFormBuilderUi/LmFormSeparatorBuilderUi'
import LmSelectBuilderUi from '@/components/lmFormBuilderUi/LmSelectBuilderUi'
import LmSuperPowerSelectV2BuilderUi from '@/components/lmFormBuilderUi/LmSuperPowerSelectV2BuilderUi'
import LmButtonBuilderUi from '@/components/lmFormBuilderUi/LmButtonBuilderUi'
import LmDateBuilderUi from '@/components/lmFormBuilderUi/LmDateBuilderUi'
import LmDateTimeBuilderUi from '@/components/lmFormBuilderUi/LmDateTimeBuilderUi'
import LmLeaFletMapBuilderUi from '@/components/lmFormBuilderUi/LmLeaFletMapBuilderUi'
import LmHtmlContentBuilderUi from '@/components/lmFormBuilderUi/LmHtmlContentBuilderUi'
import LmFormPortalBuilderUi from '@/components/lmFormBuilderUi/LmFormPortalBuilderUi'
import LmColorPickerBuilderUi from '@/components/lmFormBuilderUi/LmColorPickerBuilderUi'
import LmCommentBuilderUi from '@/components/lmFormBuilderUi/LmCommentBuilderUi'
import LmRepeatFieldsBuilderUi from '@/components/lmFormBuilderUi/LmRepeatFieldsBuilderUi'
import LmCheckboxBuilderUi from '@/components/lmFormBuilderUi/LmCheckboxBuilderUi'
import LmUploadFilesBuilderUi from '@/components/lmFormBuilderUi/LmUploadFilesBuilderUi'
import LmSignersBuilderUi from '@/components/lmFormBuilderUi/LmSignersBuilderUi'
import LmImportFromExcelBuilderUi from '@/components/lmFormBuilderUi/LmImportFromExcelBuilderUi'
import LmCustomBuilderUi from '@/components/lmFormBuilderUi/LmCustomBuilderUi'
import LmRadioBuilderUi from '@/components/lmFormBuilderUi/LmRadioBuilderUi'
import LmCodeInputBuilderUi from '@/components/lmFormBuilderUi/LmCodeInputBuilderUi'
import LmTreeSelectBuilderUi from '@/components/lmFormBuilderUi/LmTreeSelectBuilderUi'

import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import lmFormBuilderUi from '@/mixins/lmFormBuilderUi.js'

export default {
  components: {
    LmForm,
    LmSuperPowerSelectV2,
    LmTreeSelect,
    LmTextInput,
    LmTextArea,
    LmCheckbox,
    LmButton,
    LmSelect,
    LmRadio,
    LmTextNumberEditorTextAreaPasswordBuilderUi,
    LmEmailInputBuilderUi,
    LmFormSubtitlesBuilderUi,
    LmFormEmptySpaceBuilderUi,
    LmFormSeparatorBuilderUi,
    LmSelectBuilderUi,
    LmSuperPowerSelectV2BuilderUi,
    LmButtonBuilderUi,
    LmDateBuilderUi,
    LmDateTimeBuilderUi,
    LmLeaFletMapBuilderUi,
    LmHtmlContentBuilderUi,
    LmFormPortalBuilderUi,
    LmColorPickerBuilderUi,
    draggable,
    LmCommentBuilderUi,
    LmRepeatFieldsBuilderUi,
    LmCheckboxBuilderUi,
    LmUploadFilesBuilderUi,
    LmFormBuilder,
    LmSignersBuilderUi,
    LmImportFromExcelBuilderUi,
    LmCustomBuilderUi,
    LmRadioBuilderUi,
    LmCodeInputBuilderUi,
    LmTreeSelectBuilderUi
  },
  mixins: [lmToasts, lmFormBuilderUi],
  data () {
    return {
      formData: {
        typeName: '',
        typeAlias: '',
        typeDescription: '',
        typeNumerator: 'generic',
        typeComunicable: 'comunicable',
        typeVisibility: 'public',
        typeSignature: 'electronic',
        typePrefix: '',
        publish: false,
        isEditable: true,
        instancePrivileges: {}
      },
      form: {
        validations: {},
        formElements: [],
        lumbreInternal: true
      },
      initialForm: {},
      modes: {
        selected: 'edit',
        editView: true
      },
      visibilityDependOnIsChildCheckbox: false,
      isLoading: false,
      documentTypesOptionsForDuplicate: []
    }
  },
  validations: {
    formData: {
      typeName: {
        required
      },
      typeAlias: {
        required
      },
      typeDescription: {
        required
      },
      typePrefix: {
        required,
        maxLength: maxLength(5)
      }
    }
  },
  props: {
    pathToRedirectOnCancel: {
      type: String,
      default: '/listbuilder/view/6116c1efadd400578cd0e9e8'
    }
  },
  methods: {
    async onSubmit () {
      const documenttypeData = {
        ...this.formData,
        documentFields: [...this.form.formElements],
        documentFieldsValidations: this.form.validations,
        softPermissions: this.form.softPermissions
      }
      try {
        await this.validationForm(this.$v, false)
        this.isLoading = true
        if (this.isOnEditMode) {
          const r = await commonsApi.axiosPutWrapper(`/documenttypes/${this.$route.params.id}`, documenttypeData)
          this.lmToastSuccessMessage(`Se editó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se guardó exitosamente')
        } else {
          const r = await commonsApi.axiosPostWrapper(`/documenttypes/`, documenttypeData)
          this.lmToastSuccessMessage(`Se creó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se guardó exitosamente')
        }
        setTimeout(() => {
          this.isLoading = false
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        if (error?.response?.data?.message) {
          this.lmToastDangerMessage(error?.response?.data?.message, 'Error')
        } else {
          this.showToastFormError()
        }
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onPublish () {
      try {
        // Al publicar debo poder modificar nombre y descripción
        const documentTypeData = {
          ...this.formData,
          documentFields: [...this.form.formElements],
          documentFieldsValidations: this.form.validations,
          softPermissions: this.form.softPermissions
        }
        const r = await commonsApi.axiosPutWrapper(`/documenttypes/publish/${this.$route.params.id}`, documentTypeData)
        this.lmToastSuccessMessage(`Se publicó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se guardó exitosamente')
        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      }
    },
    async onDelete () {
      try {
        this.isLoading = true
        if (this.isOnEditMode) {
          const r = await commonsApi.axiosPutWrapper(`/documenttypes/delete/${this.$route.params.id}`)
          this.lmToastSuccessMessage(`Se eliminó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se eliminó exitosamente')
          setTimeout(() => {
            this.$router.push(this.pathToRedirectOnCancel)
          }, 650)
        }
      } catch (error) {
        this.lmToastDangerMessage('Lo sentimos, no se pudo eliminar el Tipo de Documento.', 'Error')
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onUnpublish () {
      try {
        this.isLoading = true
        if (this.isOnEditMode) {
          const r = await commonsApi.axiosPutWrapper(`/documenttypes/unpublish/${this.$route.params.id}`)
          this.lmToastSuccessMessage(`Se desactivó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se desactivó exitosamente')
          setTimeout(() => {
            this.$router.push(this.pathToRedirectOnCancel)
          }, 650)
        }
      } catch (error) {
        this.lmToastDangerMessage('Lo sentimos, no se pudo desactivar el Tipo de Documento.', 'Error')
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    onCancel () {
      this.$router.push(this.pathToRedirectOnCancel)
    },
    leftValueToCompareOptions (formElementToExclude) {
      return {
        disabledOption: this.$t('Element'),
        content: this.form.formElements.filter(e => e.hasOwnProperty('formObjectToSendToServerProperty')).filter(e => e.id !== formElementToExclude.id).map(e => ({ value: e.formObjectToSendToServerProperty, text: e.componentProps.label }))
      }
    },
    shouldCreatePortal (componentName) {
      return componentName !== 'LmComment'
    },
    openEditFormElement (index) {
      this.$root.$emit('bv::toggle::collapse', `collapse-${index}`)
    },
    title (component) {
      if (this.componentsOptions?.content?.length) {
        const componentLabel = component?.componentProps?.label
        const componentValue = component?.componentProps?.value
        const componentText = component?.componentProps?.text
        const { text } = this.componentsOptions.content.find(e => e.value === component?.componentName)
        let moreInfo = ''
        if (componentLabel) {
          moreInfo += ' - ' + componentLabel
        } else if (componentValue) {
          moreInfo += ' - ' + componentValue
        } else if (componentText) {
          moreInfo += ' - ' + componentText
        }
        return text + moreInfo
      } else {
        return ''
      }
    },
    addFormElement (elementIndex) {
      this.selectorElementForm('LmTextInput', elementIndex)
    },
    inputHandler (event, index) {
      this.form.formElements[index] = event
    },
    validationsChangesHandler (payload) {
      let newValidation = {}
      const formValidationHasItem = Object.keys(this.form.validations).length
      if (formValidationHasItem) {
        for (const validation in this.form.validations) {
          const existFormObjectToSendToServerPropertyForValidation = this.form.formElements.find((el) => el.formObjectToSendToServerProperty === validation)
          if (existFormObjectToSendToServerPropertyForValidation) {
            newValidation = { ...newValidation, [validation]: this.form.validations[validation] }
          }
        }
        this.form.validations = { ...newValidation, ...payload }
      } else {
        this.form.validations = { ...this.form.validations, ...payload }
      }
    },
    showToastFormError (msg = this.$t('form_with_errors')) {
      this.$bvToast.toast(msg, {
        title: 'Error',
        toaster: 'b-toaster-bottom-center',
        variant: 'danger',
        solid: true
      })
    },
    errorScrollTo () {
      VueScrollTo.scrollTo(this.id, 1000, { offset: -60 })
    },
    validationForm (validation, mustShowToat = true) {
      validation.$touch()
      if (validation.$error) {
        if (mustShowToat) {
          this.showToastFormError()
        }
        this.errorScrollTo()
        return Promise.reject(new Error('validation error'))
      } else {
        if (!validation.$pending || !validation.$error) {
          return Promise.resolve(true)
        } else {
          Promise.reject(new Error('validation error'))
        }
      }
    },
    async loadFormElements (event) {
      try {
        if (Array.isArray(event) && !event.length) {
          this.form.formElements = []
        } else {
          const documenttype = await commonsApi.axiosGetWrapper(`documenttypes/${event.id}`)
          const fields = documenttype.data.documentFields
          this.form.formElements = fields
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      this.initialForm = JSON.stringify(this.form)

      if (this.isOnEditMode) {
        const { data } = await commonsApi.axiosGetWrapper(`documenttypes/${this.$route.params.id}`)
        // Cargo las propiedades en modo edición
        for (const key in this.formData) {
          if (data.hasOwnProperty(key)) {
            this.formData[key] = data[key]
          }
        }
        this.form.formElements = data?.documentFields || []
        this.form.validations = data?.documentFieldsValidations || {}
        this.form.softPermissions = data?.softPermissions || {}

        if (this.formData.isEditable === false) {
          this.modes.selected = 'preview'
          this.modes.editView = false
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  },
  async mounted () {
    // Opciones para duplicar tipos de documento
    const documentTypes = await commonsApi.axiosGetWrapper('/documenttypes/?pageSize=100')
    const options = documentTypes.data.rows.filter(doc => doc._id !== this.$route?.params?.id).map(doc => {
      return {
        id: doc._id,
        name: doc.typeName
      }
    })
    this.documentTypesOptionsForDuplicate = options
  }
}
</script>

<style lang="sass" scoped>
.circle
  background: white
  color: black
  border-radius: 50%
  width: 25px
  height: 25px
  text-align: center
</style>
